import React from "react";

const Footer: React.FC = () => {
  const navLinks = [
    { to: "/covid-19-test-kits.html", label: "COVID-19 Test Kits" },
    { to: "/disposable-masks.html", label: "Disposable Face Masks" },
    { to: "/nitrile-gloves.html", label: "Nitrile Gloves" },
    { to: "/surface-wipes.html", label: "Surface Wipes" },
    { to: "/hand-sanitizer", label: "Hand Sanitizer" },
  ];
  const navLinks2 = [
    { to: "/about-us", label: "About Us" },
    { to: "/contact", label: "Contact Us" },
    { to: "/privacy-policy", label: "Privacy Policy" },
    { to: "/frequently-asked-questions", label: "FAQs" },
    { to: "/terms-of-use", label: "Terms of Use" },
    { to: "/terms-of-sales", label: "Terms of Sale" },
  ];
  return (
    <footer>
      {/* Footer Top Section */}
      <div className="w-full py-5 bg-[#041E42]">
        {/* This can be used for additional content if needed */}
      </div>

      {/* Footer Middle Section - Main Content */}
      <div className="w-full bg-[#041E42]">
        <div className="w-full max-w-[1710px] mx-auto px-[20px] py-[34px]">
          {/* Three equal-width sections */}
          <div className="grid grid-cols-1 md:grid-cols-3 max-w-none">
            {/* PPE Essentials Column - Left */}
            <div className="w-full">
              <h3 className="text-[18px] font-semibold mt-[5px] mb-[15px] text-white uppercase">
                PPE Essentials
              </h3>
              <ul>
                {navLinks.map((item) => (
                  <li key={item.to} className="py-2">
                    <a
                      href={item.to}
                      className="hover:underline hover:text-[#A8A88E] text-[#A8A88E] text-[15px] transition-opacity duration-200"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Information Column - Middle */}
            <div className="w-full md:px-[15px]">
              <h3 className="text-lg font-semibold mt-[5px] mb-[15px] text-white uppercase">
                Company Information
              </h3>
              <ul>
                {navLinks2.map((item) => (
                  <li key={item.to} className="py-2">
                    <a
                      href={item.to}
                      className="hover:underline hover:text-[#A8A88E] text-[#A8A88E] text-[15px] transition-opacity duration-200"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Information Column - Right */}
            <div className="w-full md:px-[15px]">
              <h3 className="text-lg font-semibold mt-[5px] mb-[15px] text-white uppercase">
                Contact Information
              </h3>
              <div>
                <div className="py-2">
                  <p className="font-normal text-[13px] text-white uppercase">
                    Address
                  </p>
                  <p className="text-[15px] text-[#A8A8A8]">
                    25 N High St 1st Floor, Canal Winchester, OH 43110
                  </p>
                </div>
                <div className="py-2">
                  <p className="font-normal text-[13px] text-white uppercase">
                    Phone
                  </p>
                  <a
                    href="tel:877-927-3691"
                    className="hover:text-[#A8A8A8] transition-colors duration-200 text-[15px] text-[#A8A8A8]"
                  >
                    877-927-3691
                  </a>
                </div>
                <div className="py-2">
                  <p className="font-normal text-[13px] text-white uppercase">
                    Email
                  </p>
                  <a
                    href="mailto:hello@ppe.us"
                    className="hover:text-[#A8A8A8] hover:underline transition-colors duration-200 text-[15px] text-[#A8A8A8]"
                  >
                    hello@ppe.us
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright Section - Full width below */}
          <div className="pt-4 w-full">
            <p className="text-[15px] text-left text-[#A8A88E]">
              PPE.us © 2023. All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
